import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { FartherAccountId, TransferId } from "../../Types";
import ValidationError from "../../ZodError";
const ContributionType = z.enum([
    "CONVERSION",
    "EMPLOYEE",
    "EMPLOYER",
    "RECHARACTERIZATION",
    "REGULAR",
    "ROLLOVER_60_DAY",
    "ROLLOVER_DIRECT",
    "TRANSFER",
    "TRUSTEE_FEE",
]);
const DepositBody = z.object({
    destinationVirtualAccountId: FartherAccountId,
    amount: z.number(),
    iraContributionDetails: z
        .object({
        contributionType: ContributionType,
        contributionYear: z.number(),
    })
        .nullable(),
});
const Response = z.object({ transferId: TransferId, message: z.string() });
export const url = () => environment() === "PROD"
    ? "https://middleware.prod.farther.com/transfer/v1/transfers/ach/deposit"
    : "https://middleware.uat.farther.com/transfer/v1/transfers/ach/deposit";
export default async function createACHDeposit(deposit, config) {
    const { data } = await axios.post(url(), convertDeposit(deposit), {
        headers: {
            Client: config.clientId,
            Authorization: `Bearer ${config.jwt}`,
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "createACHDeposit returned unexpected data.";
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
function convertDeposit(deposit) {
    return {
        destinationVirtualAccountId: deposit.fartherAccountId,
        amount: deposit.amount,
        iraContributionDetails: "contributionType" in deposit
            ? {
                contributionType: deposit.contributionType,
                contributionYear: deposit.contributionYear,
            }
            : null,
    };
}
//# sourceMappingURL=createACHDeposit.js.map